import { ILanguageSetLocale } from "app/language/store/actions"
import { ACTIONS } from "app/store/actions"
import { Action, Reducer } from "redux"
import { IUserState, SIGNUP_STATUS, SIGNUP_WIZARD_STEPS } from "user/model"
import {
  IUserActionClearSignupWizard,
  IUserActionLogin,
  IUserActionSetSignupStatus,
  IUserActionSetSignupWizardAgencyForm,
  IUserActionSetSignupWizardStep,
  IUserActionSetSignupWizardUserForm
} from "./actions"
import { getDefaultSignUpWizardState, getDefaultUserState } from "./state"

export const userReducer: Reducer<IUserState, Action> = (state: IUserState | undefined, action: Action): IUserState => {
  if (!state) {
    state = getDefaultUserState()
  }
  switch (action.type) {
    case ACTIONS.USER_START_LOGGING_IN: {
      return {
        ...state,
        isLoggingIn: true
      }
    }

    case ACTIONS.USER_STOP_LOGGING_IN: {
      return {
        ...state,
        isLoggingIn: false
      }
    }

    case ACTIONS.USER_LOGIN: {
      const { userInfo, impersonateSession } = action as IUserActionLogin
      return {
        ...state,
        isLoggingIn: false,
        isReLoginPopupOpened: false,
        ...userInfo,
        impersonate: impersonateSession
      }
    }

    case ACTIONS.USER_RENEW_SESSION: {
      const { userInfo } = action as IUserActionLogin
      return {
        ...state,
        ...userInfo
      }
    }

    case ACTIONS.USER_OPEN_RE_LOGIN_POPUP: {
      return {
        ...state,
        isReLoginPopupOpened: true
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultUserState()
    }

    case ACTIONS.USER_SIGN_UP_WIZARD_CLEAR: {
      const { locale } = action as IUserActionClearSignupWizard
      return {
        ...state,
        signup: getDefaultSignUpWizardState(locale)
      }
    }

    case ACTIONS.USER_SIGN_UP_WIZARD_CLEAR_STATUS: {
      return {
        ...state,
        signup: {
          ...state.signup,
          status: SIGNUP_STATUS.IN_PROGRESS,
          step: SIGNUP_WIZARD_STEPS.FIRST
        }
      }
    }

    case ACTIONS.LANGUAGE_SET_LOCALE: {
      const { locale } = action as ILanguageSetLocale
      return {
        ...state,
        signup: {
          ...state.signup,
          userForm: {
            ...state.signup.userForm,
            data: {
              ...state.signup.userForm.data,
              language_id: locale
            }
          },
          agencyForm: {
            ...state.signup.agencyForm,
            data: {
              ...state.signup.agencyForm.data,
              language_id: locale
            }
          }
        }
      }
    }

    case ACTIONS.USER_SIGN_UP_SET_STATUS: {
      const { status } = action as IUserActionSetSignupStatus
      return {
        ...state,
        signup: {
          ...state.signup,
          status
        }
      }
    }

    case ACTIONS.USER_SIGN_UP_WIZARD_SET_STEP: {
      const { step } = action as IUserActionSetSignupWizardStep
      return {
        ...state,
        signup: {
          ...state.signup,
          step
        }
      }
    }

    case ACTIONS.USER_SIGN_UP_WIZARD_SET_USER_FORM: {
      const { form } = action as IUserActionSetSignupWizardUserForm
      return {
        ...state,
        signup: {
          ...state.signup,
          userForm: {
            ...state.signup.userForm,
            ...form
          }
        }
      }
    }

    case ACTIONS.USER_SIGN_UP_WIZARD_SET_AGENCY_FORM: {
      const { form } = action as IUserActionSetSignupWizardAgencyForm
      return {
        ...state,
        signup: {
          ...state.signup,
          agencyForm: {
            ...state.signup.agencyForm,
            ...form
          }
        }
      }
    }

    default:
      return state
  }
}
